import React from 'react';
import useChart from '../../../../hooks/generic/charts/useChart';

const defaultChartOptions = {
  chart: {
    type: 'bar',
  },
  title: {
    text: null
  },
  plotOptions: {
    series: {
      stacking: 'normal'
    }
  },
  credits: {
    enabled: false
  }
}

const StackedBarChart = (props) => {
  const [HighchartsComponent, highchartsOptions] = useChart({
    chartOptions: {
      defaultOptions: defaultChartOptions,
      primaryOptions: props.chartOptions
    },
    configs: props.configs
  });

  return(
    <HighchartsComponent {...highchartsOptions} />
  )
}

export default StackedBarChart;